import { DeliveriesForPlace } from 'types/model/order'
import { ORDER_STATUS } from 'types/api/order'
import { LatLngExpression } from 'leaflet'
import { DeliveryShipment } from 'types/model/delivery'
import { t } from 'i18next'

export const getDriverPosition = (orders: DeliveriesForPlace[]) => {
  if (
    orders.some((order) => order.parts[0].status === ORDER_STATUS.DELIVERED) &&
    orders[0].orderStatus !== ORDER_STATUS.DELIVERED
  ) {
    const lastDeliveredOrder = orders
      .filter((order) => order.parts[0].status === ORDER_STATUS.DELIVERED)
      .slice(-1)[0]
    const index = orders.findIndex(
      (order) => order.parts[0].id === lastDeliveredOrder.parts[0].id
    )
    return orders.length > index + 1 ? orders[index + 1] : null
  }
  if (
    orders.some((order) => order.parts[0].status === ORDER_STATUS.DELIVERING)
  ) {
    return orders[0]
  }
  return null
}

export const getDriverPositionCoordinates = (
  orders: DeliveriesForPlace[],
  driverOrder: DeliveriesForPlace | null
) => {
  // use mid point coordinates knowing which order driver is on
  if (
    !driverOrder ||
    driverOrder?.shipmentData?.length < 1 ||
    !driverOrder?.shipmentData[0].midPoints
  ) {
    return null
  }
  const index = orders.findIndex(
    (order) => order.parts[0].id === driverOrder.parts[0].id
  )
  // if the distance of a step is 0, it's possible that some midPoints are null
  if (!driverOrder?.shipmentData[0].midPoints[index]) return null

  return driverOrder?.shipmentData[0].midPoints[index] as LatLngExpression
}

export const outOfSlot = (
  finishAt: string | null,
  orderDeliveryTimes: { deliveryDate: string; endTime: string }
) => {
  if (
    !finishAt ||
    !orderDeliveryTimes.deliveryDate ||
    !orderDeliveryTimes.endTime
  ) {
    return null
  }
  const timeZone = finishAt.slice(-6)
  const dateString = `${orderDeliveryTimes.deliveryDate.slice(0, 10)} ${
    orderDeliveryTimes.endTime
  } ${timeZone}`
  const finishSlotTime = new Date(dateString)
  return Boolean(new Date(finishAt).getTime() > finishSlotTime.getTime())
}

export const listOfDeliveryNames = (
  deliveries?: DeliveryShipment[],
  routeNames?: string[]
) => {
  return deliveries
    ? deliveries
        .filter(
          (delivery) =>
            delivery.orderStatus !== ORDER_STATUS.DELIVERED &&
            !routeNames?.includes(delivery.routeName)
        )
        .map((delivery) => ({
          value: `${delivery.masterShipmentId.toString()}/${delivery.id}/${
            delivery.orderIds
          }`,
          label: t('routePlanning.addToExistingShipment', {
            name: delivery.routeName,
            defaultValue: `Add to route ${delivery.routeName}`,
          }),
        }))
    : []
}
